export function mergeMediaOptions(...optionSets) {
  const merged = optionSets.reduce((acc, options) => {
    if (!options || typeof options !== "object") {
      return acc;
    }

    return {
      ...acc,
      ...options
    };
  }, {});

  return Object.keys(merged).length > 0 ? merged : undefined;
}

export function buildExternalLinkMediaOptions(asset) {
  const external = asset?.metadata?.external;
  const href = typeof external?.href === "string" ? external.href.trim() : "";

  if (!href) {
    return undefined;
  }

  return {
    href,
    hideHref: external.hideHref === true || external.hide_href === true
  };
}
